import React from "react";
import './index.css'

interface attractionBookingsPageProps{
    className?:string
}

export const AttractionBookingsPage:React.FC<attractionBookingsPageProps> = ({className})=>{
    return(
        <div className={`${className}`}>
            <h3>Attractions Bookings Page </h3>
        </div>
    )
}